import axiosUrl from "./axios.service";
import axios from "axios";
import store from "../store";

const API_URL = axiosUrl.getAxiosUrl();
const AI_ASSISTANT_PROCESSOR_URL =
  process.env.VUE_APP_AI_ASSISTANT_PROCESSOR_URL;

class AIAssistantService {
  async getAIAssistantAccessToken() {
    return await axios.post(API_URL + "/users/getAIAssistantAccessToken");
  }

  async setSession() {
    return await axios.post(
      AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/session",
      {},
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${store.state.chat.aiAssistantAccessToken.accessToken}`,
        },
      },
    );
  }

  async processPrompt(conversation, locale) {
    const payload = conversation.map((message) => ({
      messageId: message.id,
      role: message.author.id,
      conversationId: store.state.chat.currentConversationId, // CHECK
      timestamp: message.timestamp,
      content: message.text,
      attachmentIds: message.attachmentIds,
      attachments: message.attachments
    }));

    return await axios
      .post(
        AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/processPrompt",
        {
          messages: payload,
          locale: locale,
        },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }

        return null;
      })
      .catch((error) => {
        throw error;
      });
  }

  async uploadAttachment(formData) {
    return await axios.post(
      AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/uploadAttachment",
      formData,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  }

  async downloadAttachment(attachmentId) {
    return await axios.get(
      AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/downloadAttachment", {
        params: {
          attachmentId: attachmentId,
        },
        withCredentials: true,
        responseType: "blob"
      }
    );
  }
  async getAttachmentSettings() {
    return await axios
      .get(
        AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/attachmentSettings",
        {
          withCredentials: true,
        },
      )
      .then((response) => response.data);
  }

  async getAISettings() {
    return await axios.get(API_URL + "/ai/getAISettings").then((response) => {
      if (response.status === 200) {
        store.commit("chat/fillSettings", response.data);
      }
    });
  }

  async getUserConversations() {
    return await axios
      .get(API_URL + "/ai/getUserConversations")
      .then((response) => {
        if (response.status === 200) {
          store.commit(
            "chat/updateChatHistoryMessages",
            response.data.conversations,
          );
        }
      })
      .catch((error) => {
        if (error)
          store.commit("auth/updateModalError", error.response.data),
            store.commit("auth/enableModalError");
      });
  }

  async getMessagesByConversation(conversationId) {
    return await axios
      .get(API_URL + "/ai/getMessagesFromConversation", {
        params: {
          conversationId: conversationId,
        },
      })
      .then((response) => {
        store.commit("chat/setMessagesFromSelectedConversation", response.data);
      })
      .catch((error) => {
        if (error) store.commit("auth/updateModalError", error.response.data);
        store.commit("auth/enableModalError");
      });
  }

  async getMessagesByConversations(conversationIds) {
    return await axios
      .post(API_URL + "/ai/getMessagesFromConversations", {
        conversationIds: conversationIds,
      })
      .then((response) => {
        if (response.status === 200)
          store.commit(
            "chat/setMessagesPerConversation",
            response.data.messagesByConversation,
          );
      })
      .catch((error) => {
        throw error;
      });
  }

  // Feedback is server-owned and written once per message: 204 when saved, 409 when the message already has
  // feedback. conversationId is the message's own conversation, not the current one. JSON body only.
  async updateMessageRating(messageId, conversationId, rating) {
    return await axios.post(
      AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/messageRating",
      {
        messageId,
        conversationId,
        rating,
      },
      {
        withCredentials: true,
      },
    );
  }
}

export default new AIAssistantService();
